import React from 'react'
import KTScrolltop from '../../../_augmentt/_assets/js/scrolltop'

export default class ScrollTop extends React.Component {
  scrollTopCommonRef = React.createRef()

  componentDidMount() {
    const scrollTopOptions = {
      offset: 300,
      speed: 600,
    }
    // eslint-disable-next-line no-undef, no-new
    new KTScrolltop(this.scrollTopCommonRef.current, scrollTopOptions)
  }

  render() {
    return (
      <div id="kt_scrolltop" className="scrolltop" ref={this.scrollTopCommonRef}>
        <i className="la la-arrow-up" />
      </div>
    )
  }
}
